import { createRouter, createWebHistory, type Router, type RouteRecordRaw } from 'vue-router'

import './meta'
import { collectRoutes } from './collect'
import { legacyRedirects } from './legacy-redirects'
import { notFoundLocation } from './not-found'
import { notMigratedRoutes } from './not-migrated'

export { installGuards, resolveNavigation, wizardRedirect, type GuardContext, type GuardTarget } from './guards'
export { getHomeRoute } from './home'
export * from './names'
export { MISSED_QUERY, missedPath, notFoundLocation } from './not-found'

export function buildRoutes(): RouteRecordRaw[] {
  const declared = collectRoutes()
  return [
    ...declared,
    ...notMigratedRoutes(declared),
    ...legacyRedirects,
    // Legacy `*` → `error-404` (wp/shell §4.1); the unknown path rides along as `?from=` for the page to show.
    { path: '/:pathMatch(.*)*', redirect: notFoundLocation },
  ]
}

export function createAppRouter(routes: RouteRecordRaw[] = buildRoutes()): Router {
  return createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    // Legacy scrolled to the top on every navigation.
    scrollBehavior: () => ({ top: 0 }),
  })
}
